import {
    getMerchantPayout,
    addMerchantPayout,
    updateMerchantPayout,
    updateMerchantDebitBalance,
    fetchMerchantPayoutById,
    getMerchantPayoutCount,
    getIndiviudalMerchantPayoutCount,
    getLienandDebitCount,
    getLienandDebitList,
    getMerchantPayoutList,
    manualUpdatePayoutStatus
  } from "../../services/MerchantPayout";
  import {formatSuccess,formatError} from '../../services/commonServices'
  export const PAYOUT_REQUESTS_LIST_INITIATED = "PAYOUT_REQUESTS_LIST_INITIATED";
  export const PAYOUT_REQUESTS_INITIATED = "PAYOUT_REQUESTS_INITIATED";
  export const PAYOUT_REQUESTS_LIST_LOADED = "PAYOUT_REQUESTS_LIST_LOADED";
  export const PAYOUT_REQUESTS_LOADED = "PAYOUT_REQUESTS_LOADED";
  export const PAYOUT_REQUESTS_FAILED = "PAYOUT_REQUESTS_FAILED";
  export const PAYOUT_REQUESTS_COUNT_INITIATED = "PAYOUT_REQUESTS_COUNT_INITIATED";
  export const PAYOUT_REQUESTS_COUNT_LOADED = "PAYOUT_REQUESTS_COUNT_LOADED";
  export const PAYOUT_REQUESTS_COUNT_FAILED  = "PAYOUT_REQUESTS_COUNT_FAILED";

  export const PAYOUT_MERCHANT_REQUESTS_COUNT_INITIATED = "PAYOUT_MERCHANT_REQUESTS_COUNT_INITIATED";
  export const PAYOUT_MERCHANT_COUNT_LOADED = "PAYOUT_MERCHANT_COUNT_LOADED";
  export const PAYOUT_MERCHANT_COUNT_FAILED  = "PAYOUT_MERCHANT_COUNT_FAILED";

  export const PAYOUT_MERCHANT_DEBIT_AND_LIEN_COUNT_INITIATED = "PAYOUT_MERCHANT_DEBIT_AND_LIEN_COUNT_INITIATED";
  export const PAYOUT_MERCHANT_DEBIT_AND_LIEN_COUNT_LOADED = "PAYOUT_MERCHANT_DEBIT_AND_LIEN_COUNT_LOADED";
  export const PAYOUT_MERCHANT_DEBIT_AND_LIEN_COUNT_FAILED  = "PAYOUT_MERCHANT_DEBIT_AND_LIEN_COUNT_FAILED";

  export const PAYOUT_MERCHANT_DEBIT_AND_LIEN_INITIATED = "PAYOUT_MERCHANT_DEBIT_AND_LIEN_INITIATED";
  export const PAYOUT_MERCHANT_DEBIT_AND_LIEN_LOADED = "PAYOUT_MERCHANT_DEBIT_AND_LIEN_LOADED";
  export const PAYOUT_MERCHANT_DEBIT_AND_LIEN_FAILED  = "PAYOUT_MERCHANT_DEBIT_AND_LIEN_FAILED";

  export const MERCHANT_PAYOUT_LIST_INITIATED = "MERCHANT_PAYOUT_LIST_INITIATED";
  export const MERCHANT_PAYOUT_LIST_LOADED = "MERCHANT_PAYOUT_LIST_LOADED";
  export const MERCHANT_PAYOUT_LIST_FAILED  = "MERCHANT_PAYOUT_LIST_FAILED";

  export const MANUAL_UPDATE_STATUS_INITIATED = "MANUAL_UPDATE_STATUS_INITIATED";
  export const MANUAL_UPDATE_STATUS_LOADED = "MANUAL_UPDATE_STATUS_LOADED";
  export const MANUAL_UPDATE_STATUS_FAILED = "MANUAL_UPDATE_STATUS_FAILED";
  
  export const loadMerchantPayout = (getData) => {
    return (dispatch) => {
      dispatch({ type: PAYOUT_REQUESTS_LIST_INITIATED });
      getMerchantPayout(getData)
        .then((response) => {
          dispatch({ type: PAYOUT_REQUESTS_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: PAYOUT_REQUESTS_FAILED, payload: error.message });
        });
    };
  };

  export const loadMerchantPayoutList = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_PAYOUT_LIST_INITIATED });
      getMerchantPayoutList(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_PAYOUT_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_PAYOUT_LIST_FAILED, payload: error.message });
        });
    };
  };

  export const loadMerchantDebitandLien = (getData) => {
    return (dispatch) => {
      dispatch({ type: PAYOUT_MERCHANT_DEBIT_AND_LIEN_INITIATED });
      getLienandDebitList(getData)
        .then((response) => {
          dispatch({ type: PAYOUT_MERCHANT_DEBIT_AND_LIEN_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: PAYOUT_MERCHANT_DEBIT_AND_LIEN_FAILED, payload: error.message });
        });
    };
  };

  export const loadMerchantPayoutCount = (getData) => {
    return (dispatch) => {
      dispatch({ type: PAYOUT_REQUESTS_COUNT_INITIATED });
      getMerchantPayoutCount(getData)
        .then((response) => {
          dispatch({ type: PAYOUT_REQUESTS_COUNT_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: PAYOUT_REQUESTS_COUNT_FAILED, payload: error.message });
        });
    };
  };

  export const loadMerchantDebitandLienCount = (getData) => {
    return (dispatch) => {
      dispatch({ type: PAYOUT_MERCHANT_DEBIT_AND_LIEN_COUNT_INITIATED });
      getLienandDebitCount(getData)
        .then((response) => {
          dispatch({ type: PAYOUT_MERCHANT_DEBIT_AND_LIEN_COUNT_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: PAYOUT_MERCHANT_DEBIT_AND_LIEN_COUNT_FAILED, payload: error.message });
        });
    };
  };


  export const loadIndiviudalMerchantPayoutCount = (getData) => {
    return (dispatch) => {
      dispatch({ type: PAYOUT_MERCHANT_REQUESTS_COUNT_INITIATED });
      getIndiviudalMerchantPayoutCount(getData)
        .then((response) => {
          dispatch({ type: PAYOUT_MERCHANT_COUNT_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: PAYOUT_MERCHANT_COUNT_FAILED, payload: error.message });
        });
    };
  };

  

  

  export const getMerchantPayoutById = (id) => {
    return (dispatch) => {
      dispatch({ type: PAYOUT_REQUESTS_INITIATED });
      return fetchMerchantPayoutById(id)
        .then((response) => {
          dispatch({ type: PAYOUT_REQUESTS_LOADED, payload: response.data });
        })
        .catch((error) => {
          dispatch({ type: PAYOUT_REQUESTS_FAILED, payload: formatError(error) });
        });
    };
  };
  
  export const debitMerchantBalance = (data, isEdit, id, navigate) => {
    return (dispatch) => {
      dispatch({ type: PAYOUT_REQUESTS_INITIATED });
      const apiCall = isEdit ? updateMerchantDebitBalance(data) : updateMerchantDebitBalance(data);
      return apiCall
        .then((response) => {
          formatSuccess('Debit request', response.data)
          setTimeout(()=>{
            navigate('/debit-funds');
          },1000)
        })
        .catch((error) => {
          if(error && error.response && error.response.data){
            dispatch({ type: PAYOUT_REQUESTS_FAILED, payload: formatError(error.response.data) });
          }
          else{
            dispatch({ type: PAYOUT_REQUESTS_FAILED, payload: formatError(error.message) });
          }
        });
    };
  };

  export const saveMerchantPayoutAction = (data, isEdit, id, navigate) => {
    return (dispatch) => {
      dispatch({ type: PAYOUT_REQUESTS_INITIATED });
      const apiCall = isEdit ? updateMerchantPayout(id, data) : addMerchantPayout(data);
      return apiCall
        .then((response) => {
          formatSuccess('Fund Request', response.data)
          setTimeout(()=>{
            navigate('/fund-requests');
          },1000)
        })
        .catch((error) => {
          if(error && error.response && error.response.data){
            dispatch({ type: PAYOUT_REQUESTS_FAILED, payload: formatError(error.response.data) });
          }
          else{
            dispatch({ type: PAYOUT_REQUESTS_FAILED, payload: formatError(error.message) });
          }
        });
    };
  };

  export const updateManualPayoutStatus = (data) => {
    return (dispatch) => {
      dispatch({ type: MANUAL_UPDATE_STATUS_INITIATED });
      return manualUpdatePayoutStatus(data)
        .then((response) => {
          dispatch({ type: MANUAL_UPDATE_STATUS_LOADED, payload: response.data.data });
          return response;
        })
        .catch((error) => {
          const errorMsg = error?.response?.data?.message || error?.message || 'Status update failed';
          dispatch({ type: MANUAL_UPDATE_STATUS_FAILED, payload: errorMsg });
          throw error;
        });
    };
  };